import { Button, Modal, Table } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'

const KakaoTemplateModal = ({
  open,
  onCancel,
  onSelect,
  kakaoTemplateList,
  totalElements,
  currentPage,
  onPageChange,
  selectedKakaoTemplate,
}) => {
  const [selectedRowKey, setSelectedRowKey] = useState([])

  useEffect(() => {
    // console.log('selectedCouponId', selectedCoupon)
    if (selectedKakaoTemplate && selectedKakaoTemplate.templateId) {
      setSelectedRowKey([selectedKakaoTemplate.templateId])
    }
  }, [selectedKakaoTemplate])

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys) => {
      setSelectedRowKey(selectedRowKeys)
    },
  }

  const columns = [
    {
      title: '템플릿 ID',
      dataIndex: 'templateId',
      key: 'templateId',
      width: 80,
      ellipsis: true,
    },
    {
      title: '템플릿 이름',
      dataIndex: 'title',
      key: 'title',
      width: 180,
      ellipsis: true,
    },
    {
      title: '알림톡 내용',
      dataIndex: 'content',
      key: 'content',
      width: 300,
      ellipsis: true,
    },
    {
      title: '변수 목록',
      dataIndex: 'variableList',
      key: 'variableList',
      width: 200,
      ellipsis: true,
      render: (value) => {
        if (value && Array.isArray(value)) {
          return value.join(', ')
        }
        return value || '-'
      },
    },
    {
      title: '생성일',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 140,
      ellipsis: true,
      render: (value) =>
        value ? dayjs(value).format('YYYY.MM.DD HH:mm') : '-',
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
  ]

  const handleSelect = () => {
    const selectedData = kakaoTemplateList.find(
      (item) => item.templateId === selectedRowKey[0],
    )
    if (selectedData) {
      onSelect(selectedData)
      onCancel()
    }
  }

  const onRow = (record) => ({
    onClick: () => {
      setSelectedRowKey([record.templateId])
    },
    style: {
      cursor: 'pointer',
    },
  })

  const handlePageChange = (page, pageSize) => {
    // console.log('모달 페이지 변경:', { page, pageSize })
    if (onPageChange) {
      onPageChange(page, pageSize)
    }
  }

  // 실제 총 페이지 수 계산
  const actualTotalPages = Math.ceil(totalElements / 10)

  return (
    <Modal
      title="카카오 알림톡 템플릿 선택"
      open={open}
      onCancel={onCancel}
      width={1200}
      centered
      footer={[
        <Button key="cancel" onClick={onCancel}>
          취소
        </Button>,
        <Button
          key="select"
          type="primary"
          onClick={handleSelect}
          disabled={!selectedRowKey.length}
        >
          선택
        </Button>,
      ]}
    >
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={kakaoTemplateList}
        bordered
        size="middle"
        rowKey="templateId"
        scroll={{ y: 'calc(100vh - 400px)' }}
        pagination={{
          current: currentPage,
          total: totalElements,
          pageSize: 10,
          onChange: handlePageChange,
        }}
        onRow={onRow}
      />
    </Modal>
  )
}

export default KakaoTemplateModal
